import { HeroSection } from "@/components/sections/HeroSection";
import { ModulesSection } from "@/components/sections/ModulesSection";
import { OverviewSection } from "@/components/sections/OverviewSection";

const Index = () => {
  return (
    <div className="space-y-0">
      <HeroSection />
      <OverviewSection />
      <ModulesSection />
    </div>
  );
};

export default Index;
